import {
  SEARCH_SUGGESTED_PRODUCTS,
  SEARCH_SUGGESTED_PRODUCTS_SUCCESS,
  SEARCH_SUGGESTED_PRODUCTS_ERROR,
  CREATE_SUGGESTED_PRODUCT,
  CREATE_SUGGESTED_PRODUCT_SUCCESS,
  CREATE_SUGGESTED_PRODUCT_ERROR,
  UPDATE_SUGGESTED_PRODUCT,
  UPDATE_SUGGESTED_PRODUCT_SUCCESS,
  UPDATE_SUGGESTED_PRODUCT_ERROR,
  DELETE_SUGGESTED_PRODUCT,
  DELETE_SUGGESTED_PRODUCT_SUCCESS,
  DELETE_SUGGESTED_PRODUCT_ERROR,
  CLEAR_SUGGESTED_PRODUCT_STATE,
  SEARCH_SUGGESTED_PRODUCTS_BY_CLIENT,
  SEARCH_SUGGESTED_PRODUCTS_BY_CLIENT_SUCCESS,
  SEARCH_SUGGESTED_PRODUCTS_BY_CLIENT_ERROR,
  GET_SPECIALTIES_SUCCESS,
  GET_SPECIALTIES_ERROR,
} from '../constants/ActionsTypes'

const initialState = {
  search: undefined,
  searchRequest: null,
  clientSearch: {},
  isLoadingClientSearch: {},
  isSaving: false,
  isDeleting: false,
  saveSuccess: false,
  deleteSuccess: false,
  specialtyList: [],
  error: null,
}

function rootReducer(state = initialState, action) {
  switch (action.type) {
    case SEARCH_SUGGESTED_PRODUCTS:
      return { ...state, searchRequest: action.payload, saveSuccess: false, deleteSuccess: false }
    case SEARCH_SUGGESTED_PRODUCTS_SUCCESS:
      return { ...state, search: action.payload.response }
    case SEARCH_SUGGESTED_PRODUCTS_ERROR:
      return { ...state, error: action.payload }

    case CREATE_SUGGESTED_PRODUCT:
    case UPDATE_SUGGESTED_PRODUCT:
      return { ...state, isSaving: true, saveSuccess: false, error: null }
    case CREATE_SUGGESTED_PRODUCT_SUCCESS:
    case UPDATE_SUGGESTED_PRODUCT_SUCCESS:
      return { ...state, isSaving: false, saveSuccess: true, error: null }
    case CREATE_SUGGESTED_PRODUCT_ERROR:
    case UPDATE_SUGGESTED_PRODUCT_ERROR:
      return { ...state, isSaving: false, saveSuccess: false, error: action.payload }

    case DELETE_SUGGESTED_PRODUCT:
      return { ...state, isDeleting: true, deleteSuccess: false, error: null }
    case DELETE_SUGGESTED_PRODUCT_SUCCESS:
      return { ...state, isDeleting: false, deleteSuccess: true, error: null }
    case DELETE_SUGGESTED_PRODUCT_ERROR:
      return { ...state, isDeleting: false, deleteSuccess: false, error: action.payload }

    case SEARCH_SUGGESTED_PRODUCTS_BY_CLIENT: {
      const requestKey = action.payload?.displayLocation || 'default'
      return {
        ...state,
        isLoadingClientSearch: { ...state.isLoadingClientSearch, [requestKey]: true },
        error: null,
      }
    }
    case SEARCH_SUGGESTED_PRODUCTS_BY_CLIENT_SUCCESS: {
      const successKey = action.displayLocation || 'default'
      return {
        ...state,
        isLoadingClientSearch: { ...state.isLoadingClientSearch, [successKey]: false },
        clientSearch: { ...state.clientSearch, [successKey]: action.payload.response },
      }
    }
    case SEARCH_SUGGESTED_PRODUCTS_BY_CLIENT_ERROR: {
      const errorKey = action.displayLocation || 'default'
      return {
        ...state,
        isLoadingClientSearch: { ...state.isLoadingClientSearch, [errorKey]: false },
        error: action.payload,
      }
    }

    case GET_SPECIALTIES_SUCCESS:
      return { ...state, specialtyList: action.payload.data }
    case GET_SPECIALTIES_ERROR:
      return { ...state, error: action.payload }

    case CLEAR_SUGGESTED_PRODUCT_STATE:
      return initialState

    default:
      return state
  }
}

export default rootReducer
